/* eslint-disable array-callback-return */
import { POST_AUTH_TEAM_FAILURE, UPDATE_AUTH_TEAM_FAILURE, UPDATE_AUTHORIZATIONS_FAILURE } from '../store/types/authorizationTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';
import { postTeam, updateAuthorizationSummary, updateTeam } from '../store/actions/authorizations.actions';

const normalizeRepTypeId = (id) => (id || '').toString().toLowerCase();

const findRepInternalUserId = (members, representativeTypeId) => {
  const normalizedTypeId = normalizeRepTypeId(representativeTypeId);
  return members?.find((member) => normalizeRepTypeId(member.authorizationFileRepresentativeTypeId) === normalizedTypeId)?.internalUserId || null;
};

const findRepIndex = (members, representativeTypeId) => {
  const normalizedTypeId = normalizeRepTypeId(representativeTypeId);
  return members.findIndex((member) => normalizeRepTypeId(member.authorizationFileRepresentativeTypeId) === normalizedTypeId);
};

const dedupeRepresentativesByType = (members) => {
  const deduped = [];
  const seenByType = {};

  members.forEach((member) => {
    const key = normalizeRepTypeId(member.authorizationFileRepresentativeTypeId);
    const existingIndex = seenByType[key];

    if (existingIndex === undefined) {
      seenByType[key] = deduped.length;
      deduped.push(member);
      return;
    }

    deduped[existingIndex] = {
      ...deduped[existingIndex],
      ...member
    };
  });

  return deduped;
};

const TeamCard = props => {
  const [isLoading, setIsLoading] = useState(false);

  const { teamMembers } = props;
  const teamOptionsRaw = props.teamsEnum ? props.teamsEnum.sort((a, b) => a.title.localeCompare(b.title)) : [];
  const teamOptions = teamOptionsRaw
    .filter(team => team?.isActive !== false)
    .map(team => ({
      id: team.id || team.teamId || team.enumerationId,
      title: team.title || team.name || team.description
    }))
    .filter(team => team.id && team.title);

  const summaryTabs = [{ header: 'Team', order: 1, iconPath: ['fa', 'people-group'] }];

  const internalUserTypes =
    props.internalUserTypesEnum && props.internalUserTypesEnum.length > 0
      ? props.internalUserTypesEnum.filter(s => s.isActive === true)
      : [];

  const internalUsersMapping = [];

  if (props.internalUsers) {
    props.internalUsers.map((iu) => {
      const internalUserType = internalUserTypes.find((iut) => iut.id === iu.internalUserTypeId)?.title;
      internalUsersMapping.push({
        title: `${iu.firstName} ${iu.lastName} (${internalUserType})`,
        id: iu.internalUserId
      })
    })
  }

  const fields = [
    {
      header: 'Counselor',
      accessorKey: 'counselor',
      type: 'dropdown-v2',
      options: internalUsersMapping,
      required: false,
      value: findRepInternalUserId(teamMembers, '78bf4f32-f363-4de0-8797-bc35835e7eb2'),
      tab: 1
    },
    {
      header: 'Expense Analyst',
      accessorKey: 'expenseAnalyst',
      type: 'dropdown-v2',
      options: internalUsersMapping,
      required: false,
      value: findRepInternalUserId(teamMembers, '9c3a4764-75bc-47a7-9f1b-bd66ec7c4b3c'),
      tab: 1
    },
    {
      header: 'Team',
      accessorKey: 'teamId',
      type: 'dropdown-v2',
      options: teamOptions,
      required: false,
      value: props.authorizationDetails?.teamId || null,
      tab: 1,
      hideInTable: true
    },
    {
      header: 'RC Reports To',
      accessorKey: 'reportsTo',
      type: 'dropdown-v2',
      options: internalUsersMapping,
      required: false,
      value: findRepInternalUserId(teamMembers, 'b81523d3-07bf-4778-81a5-330cb02af041'),
      tab: 1,
      hideInTable: true
    },
    {
      header: 'DSD',
      accessorKey: 'dsd',
      type: 'dropdown-v2',
      options: internalUsersMapping,
      required: false,
      value: findRepInternalUserId(teamMembers, '77c39648-d167-4d71-8dae-5cdd43f5f6b4'),
      tab: 1,
      hideInTable: true
    },
    {
      header: 'CSS',
      accessorKey: 'css',
      type: 'dropdown-v2',
      options: internalUsersMapping,
      required: false,
      value: findRepInternalUserId(teamMembers, '85645814-f990-4e7b-b1f0-017404c04d42'),
      tab: 1,
      hideInTable: true
    },
    {
      header: 'CSM',
      accessorKey: 'csm',
      type: 'dropdown-v2',
      options: internalUsersMapping,
      required: false,
      value: findRepInternalUserId(teamMembers, '2be59a1e-2687-4518-90f5-1c347674635d'),
      tab: 1,
      hideInTable: true
    },
    {
      header: 'Inventory SP',
      accessorKey: 'inventorySP',
      type: 'dropdown-v2',
      options: internalUsersMapping,
      required: false,
      value: findRepInternalUserId(teamMembers, '7387e56c-73da-4254-a5c6-05ead8cbe5fc'),
      tab: 1,
      hideInTable: true
    },
    {
      header: 'Payroll SP',
      accessorKey: 'payrollSP',
      type: 'dropdown-v2',
      options: internalUsersMapping,
      required: false,
      value: findRepInternalUserId(teamMembers, '5e9a7ee5-93f3-4e7a-96c2-14d5a6eb4c11'),
      tab: 1,
      hideInTable: true
    },
    {
      header: 'Global CA',
      accessorKey: 'globalCA',
      type: 'dropdown-v2',
      options: internalUsersMapping,
      required: false,
      value: findRepInternalUserId(teamMembers, 'c4b6f70e-0f8e-4c9b-9a76-2d1c5ea93b2f'),
      tab: 1,
      hideInTable: true
    },
  ];

  const updateFields = async (tab, values) => {
    setIsLoading(true);

    const fileId = Number(props.id);

    const newAuthorizationDetails = {
      ...props.authorizationDetails,
      teamId: values.teamId || null
    };

    const authResp = await props.updateAuthorizationSummary(newAuthorizationDetails);
    if (authResp.type === UPDATE_AUTHORIZATIONS_FAILURE) {
      props.showToast('Failed to update team info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    }

    const hasRepresentativeValues = Boolean(
      values.counselor ||
      values.css ||
      values.dsd ||
      values.expenseAnalyst ||
      values.inventorySP ||
      values.payrollSP ||
      values.globalCA ||
      values.reportsTo ||
      values.csm
    );


    if (teamMembers && teamMembers.length !== 0) {

      let newTeamList = dedupeRepresentativesByType([...teamMembers]);

      if (values.counselor) {
        const counselorIndex = findRepIndex(newTeamList, '78bf4f32-f363-4de0-8797-bc35835e7eb2');
        if (counselorIndex !== -1) {
          newTeamList[counselorIndex].internalUserId = values.counselor;
        } else {
          newTeamList.push({
            fileId: fileId,
            authorizationFileRepresentativeTypeId: '78bf4f32-f363-4de0-8797-bc35835e7eb2',
            internalUserId: values.counselor
          })
        }
      }
      if (values.css) {
        const cssIndex = findRepIndex(newTeamList, '85645814-f990-4e7b-b1f0-017404c04d42');
        if (cssIndex !== -1) {
          newTeamList[cssIndex].internalUserId = values.css;
        } else {
          newTeamList.push({
            fileId: fileId,
            authorizationFileRepresentativeTypeId: '85645814-f990-4e7b-b1f0-017404c04d42',
            internalUserId: values.css
          })
        }
      }
      if (values.dsd) {
        const dsdIndex = findRepIndex(newTeamList, '77c39648-d167-4d71-8dae-5cdd43f5f6b4');
        if (dsdIndex !== -1) {
          newTeamList[dsdIndex].internalUserId = values.dsd;
        } else {
          newTeamList.push({
            fileId: fileId,
            authorizationFileRepresentativeTypeId: '77c39648-d167-4d71-8dae-5cdd43f5f6b4',
            internalUserId: values.dsd
          })
        }
      }
      if (values.expenseAnalyst) {
        const expIndex = findRepIndex(newTeamList, '9c3a4764-75bc-47a7-9f1b-bd66ec7c4b3c');
        if (expIndex !== -1) {
          newTeamList[expIndex].internalUserId = values.expenseAnalyst;
        } else {
          newTeamList.push({
            fileId: fileId,
            authorizationFileRepresentativeTypeId: '9c3a4764-75bc-47a7-9f1b-bd66ec7c4b3c',
            internalUserId: values.expenseAnalyst
          })
        }
      }
      if (values.inventorySP) {
        const inventorySPIndex = findRepIndex(newTeamList, '7387e56c-73da-4254-a5c6-05ead8cbe5fc');
        if (inventorySPIndex !== -1) {
          newTeamList[inventorySPIndex].internalUserId = values.inventorySP;
        } else {
          newTeamList.push({
            fileId: fileId,
            authorizationFileRepresentativeTypeId: '7387e56c-73da-4254-a5c6-05ead8cbe5fc',
            internalUserId: values.inventorySP
          })
        }
      }
      if (values.payrollSP) {
        const payrollSPIndex = findRepIndex(newTeamList, '5e9a7ee5-93f3-4e7a-96c2-14d5a6eb4c11');
        if (payrollSPIndex !== -1) {
          newTeamList[payrollSPIndex].internalUserId = values.payrollSP;
        } else {
          newTeamList.push({
            fileId: fileId,
            authorizationFileRepresentativeTypeId: '5e9a7ee5-93f3-4e7a-96c2-14d5a6eb4c11',
            internalUserId: values.payrollSP
          })
        }
      }
      if (values.globalCA) {
        const globalCAIndex = findRepIndex(newTeamList, 'c4b6f70e-0f8e-4c9b-9a76-2d1c5ea93b2f');
        if (globalCAIndex !== -1) {
          newTeamList[globalCAIndex].internalUserId = values.globalCA;
        } else {
          newTeamList.push({
            fileId: fileId,
            authorizationFileRepresentativeTypeId: 'c4b6f70e-0f8e-4c9b-9a76-2d1c5ea93b2f',
            internalUserId: values.globalCA
          })
        }
      }
      if (values.reportsTo) {
        const reportsToIndex = findRepIndex(newTeamList, 'b81523d3-07bf-4778-81a5-330cb02af041');
        if (reportsToIndex !== -1) {
          newTeamList[reportsToIndex].internalUserId = values.reportsTo;
        } else {
          newTeamList.push({
            fileId: fileId,
            authorizationFileRepresentativeTypeId: 'b81523d3-07bf-4778-81a5-330cb02af041',
            internalUserId: values.reportsTo
          })
        }
      }
      if (values.csm) {
        const csmIndex = findRepIndex(newTeamList, '2be59a1e-2687-4518-90f5-1c347674635d');
        if (csmIndex !== -1) {
          newTeamList[csmIndex].internalUserId = values.csm;
        } else {
          newTeamList.push({
            fileId: fileId,
            authorizationFileRepresentativeTypeId: '2be59a1e-2687-4518-90f5-1c347674635d',
            internalUserId: values.csm
          })
        }
      }

      if (!hasRepresentativeValues) {
        setIsLoading(false);
        return true;
      }

      const resp = await props.updateTeam(dedupeRepresentativesByType(newTeamList), fileId);
      if (resp.type === UPDATE_AUTH_TEAM_FAILURE) {
        props.showToast('Failed to update team info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        setIsLoading(false);
        return false;
      } else {
        setIsLoading(false);
        return true;
      }
    } else {
      const newTeamList = [];

      if (values.counselor) {
        newTeamList.push({
          fileId: fileId,
          authorizationFileRepresentativeTypeId: '78bf4f32-f363-4de0-8797-bc35835e7eb2',
          internalUserId: values.counselor
        })
      }
      if (values.css) {
        newTeamList.push({
          fileId: fileId,
          authorizationFileRepresentativeTypeId: '85645814-f990-4e7b-b1f0-017404c04d42',
          internalUserId: values.css
        })
      }
      if (values.dsd) {
        newTeamList.push({
          fileId: fileId,
          authorizationFileRepresentativeTypeId: '77c39648-d167-4d71-8dae-5cdd43f5f6b4',
          internalUserId: values.dsd
        })
      }
      if (values.expenseAnalyst) {
        newTeamList.push({
          fileId: fileId,
          authorizationFileRepresentativeTypeId: '9c3a4764-75bc-47a7-9f1b-bd66ec7c4b3c',
          internalUserId: values.expenseAnalyst
        })
      }
      if (values.inventorySP) {
        newTeamList.push({
          fileId: fileId,
          authorizationFileRepresentativeTypeId: '7387e56c-73da-4254-a5c6-05ead8cbe5fc',
          internalUserId: values.inventorySP
        })
      }
      if (values.payrollSP) {
        newTeamList.push({
          fileId: fileId,
          authorizationFileRepresentativeTypeId: '5e9a7ee5-93f3-4e7a-96c2-14d5a6eb4c11',
          internalUserId: values.payrollSP
        })
      }
      if (values.globalCA) {
        newTeamList.push({
          fileId: fileId,
          authorizationFileRepresentativeTypeId: 'c4b6f70e-0f8e-4c9b-9a76-2d1c5ea93b2f',
          internalUserId: values.globalCA
        })
      }
      if (values.reportsTo) {
        newTeamList.push({
          fileId: fileId,
          authorizationFileRepresentativeTypeId: 'b81523d3-07bf-4778-81a5-330cb02af041',
          internalUserId: values.reportsTo
        })
      }
      if (values.csm) {
        newTeamList.push({
          fileId: fileId,
          authorizationFileRepresentativeTypeId: '2be59a1e-2687-4518-90f5-1c347674635d',
          internalUserId: values.csm
        })
      }

      if (newTeamList.length === 0) {
        setIsLoading(false);
        return true;
      }

      const resp = await props.postTeam(dedupeRepresentativesByType(newTeamList), fileId);
      if (resp.type === POST_AUTH_TEAM_FAILURE) {
        props.showToast('Failed to update team info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        setIsLoading(false);
        return false;
      } else {
        setIsLoading(false);
        return true;
      }
    }
  };

  return (
    <EditableCard
      tabs={summaryTabs}
      summaries={fields}
      numColumns={2}
      updateFields={updateFields}
      isLoading={isLoading}
      hideEdit={Boolean(props.hideEdit)}
    />
  );
};

const mapStateToProps = state => {
  const { internalUserTypes, teams, Teams } = state.enumerations.allEnums;
  const { internalUsers } = state.common;

  return {
    internalUserTypesEnum: internalUserTypes,
    teamsEnum: teams || Teams || [],
    internalUsers
  };
};

export default compose(
  connect(mapStateToProps, {
    postTeam,
    updateTeam,
    updateAuthorizationSummary,
    showToast
  })
)(TeamCard);
